import type { LibraryDocument } from '../types/documentLibrary.types'

/**
 * Human-readable Source label for the my-library Source column.
 *
 * The scope FKs come back from the backend populated via
 * `.populate('project', 'projectName')` / `.populate('portfolio',
 * 'assetName')` / `.populate('location', 'assetName')`, so we read
 * the populated subfield. Falls back gracefully when the FK is a
 * bare-string ObjectId (test fixtures) or when populate failed.
 *
 * Format keeps the type prefix in the displayed value so sorting
 * groups by type first, then alphabetically by parent name.
 */
export const sourceLabel = (doc: LibraryDocument): string => {
	const scope = doc.scope || 'project'
	const pick = (
		fk: unknown,
		key: 'projectName' | 'assetName',
	): string | null => {
		if (!fk || typeof fk === 'string') return null
		return ((fk as Record<string, unknown>)[key] as string) || null
	}
	switch (scope) {
		case 'project': {
			const name = pick(doc.project, 'projectName')
			return name ? `Project: ${name}` : 'Project'
		}
		case 'portfolio': {
			const name = pick(doc.portfolio, 'assetName')
			return name ? `Portfolio: ${name}` : 'Portfolio'
		}
		case 'location': {
			const name = pick(doc.location, 'assetName')
			return name ? `Location: ${name}` : 'Location'
		}
		case 'global':
			return 'Global Library'
		default:
			return ''
	}
}
